import React, { createContext, useContext, useEffect, useState } from 'react';
import { getBrandingOverrides } from './getBrandingOverrides';
import { defaults } from './defaultBranding';
import { merge } from 'lodash';

export const BrandingContext = createContext({
  branding: { ...defaults },
});

// setup and get the branding provider
export const BrandingProvider = ({ children, tenantId }) => {
  const [branding, setBranding] = useState({
    ...defaults,
  });

  const [isBranded, setIsBranded] = useState(false);

  useEffect(() => {
    async function loadBranding() {
      const brand = await getBrandingOverrides(tenantId);
      if (brand.length === 0) return;

      setBranding(merge(branding, { ...brand[0] }));
      setIsBranded(true);
    }

    loadBranding();
  }, [tenantId]);

  return (
    <BrandingContext.Provider value={{ branding, setBranding, isBranded }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = (context = BrandingContext) => {
  const brandingContext = useContext(context);

  if (brandingContext === undefined) {
    throw new Error('UseBranding must be used within Branding context');
  }

  return {
    branding: brandingContext.branding,
    isBranded: brandingContext.isBranded,
  };
};
